module.exports = __webpack_public_path__ + "static/img/good5.3ba901a8.png";